<template>
  <div class="shares" v-on:mouseover="hover()" v-on:mouseleave="hide()" :class="{ active: this.isActive }">
    <div class="share-button" @click="isActive = !isActive"></div>
    <div class="shares-links">
      <social-sharing url="http://gaviscon.afisha.ru/"
                      title="#отфудбольизжогу"
                      description="Покажи, как ты болеешь за любимую команду и получи шанс выиграть гастротур на двоих в Бразилию!  "
                      quote="Покажи, как ты болеешь за любимую команду и получи шанс выиграть гастротур на двоих в Бразилию!  "
                      hashtags="отфудбольизжогу,гевискон"
                      v-cloak inline-template>
        <ul>
          <li @click="$ga.event('Шаринг', 'Шаринг вконтакте', 1)">
            <network network="vk" id="vk">
              <i class="icon icon-vk"></i>
            </network>
          </li>

          <li @click="$ga.event('Шаринг', 'Шаринг facebook', 1)">
            <network network="facebook" id="facebook">
              <i class="icon icon-facebook"></i>
            </network>
          </li>
          <li @click="$ga.event('Шаринг', 'Шаринг twitter', 1)">
            <network network="twitter" id="twitter">
              <i class="icon icon-twitter"></i>
            </network>
          </li>
          <li @click="$ga.event('Шаринг', 'Шаринг одноклассники', 1)">
            <network network="odnoklassniki" id="odnoklassniki">
              <i class="icon icon-odnoklassniki"></i>
            </network>
          </li>
        </ul>
      </social-sharing>
    </div>
  </div>
</template>

<script>
    export default {
        name: "ShareBlock",
        components: {},
        data() {
            return {
                isActive: false,
                timerId: null
            }
        },
        methods: {
            hover() {
                if (this.$mq !== 'mobile') {
                    this.isActive = true;
                }

            },
            hide() {
                clearTimeout(this.timerId);
                var that = this;
                this.timerId = setTimeout(function () {
                    that.isActive = false;
                }, 500)
            },
            sendGa(method) {
                this.$ga.event('Шаринг', 'Шаринг ' + method, 1);

            }
        },
        computed: {
            aClass() {
                return (this.isActive === true) ? ' active' : ''
            }
        }

    }
</script>

<style lang="scss">
  .icon {
    width: 20px;
    height: 20px;
    background-repeat: no-repeat;
    background-position: center center;
    display: inline-flex;
    &:hover {
      opacity: 0.8;
    }
    &.icon-vk {
      background-image: url("../assets/icons/ico__vk.svg");
    }
    &.icon-facebook {
      background-image: url("../assets/icons/ico__fb.svg");
    }
    &.icon-twitter {
      background-image: url("../assets/icons/ico__tw.svg");
    }
    &.icon-odnoklassniki {
      background-image: url("../assets/icons/ico__ok.svg");
    }
  }

  .shares {
    position: fixed;
    right: 45px;
    bottom: 9vh;
    z-index: 500;

    display: flex;
    align-items: center;
    justify-content: space-between;
    transition: all 300ms ease-in-out;
    flex-direction: row-reverse;
    overflow: hidden;
    ul {
      display: flex;
      margin: 0;
      padding: 0;
      li {
        display: flex;
        margin: 4px 8px 0 8px;
      }
    }
    .shares-links {
      display: flex;
      opacity: 0;
      transition: all .5s cubic-bezier(1.0, 0.5, 0.8, 1.0);
      transform: translateX(-200px);
    }
    .share-button {
      background-color: white;
      mask-image: url("../assets/icons/ico__heart.svg");
      width: 15px;
      height: 14px;
      background-size: contain;
      cursor: pointer;
      display: inline-flex;
      &:hover {
        background-color: red;
        mask-image: url("../assets/icons/ico__heart_hover.svg");
      }
    }

    &.active {
      .share-button {
        background-color: red;
        mask-image: url("../assets/icons/ico__heart_hover.svg");
      }
      .shares-links {
        visibility: visible;
        transition: all .3s ease;
        opacity: 1;
        transform: none;
        z-index: 1000;
      }
    }

  }

  .share-result {
    .icon {
      width: 25px !important;
      height: 25px !important;
    }
  }

  @media screen and (max-width: 768px) {
    .shares {
      bottom: 63px;
      z-index: 200;
      right: 20px;
    }
  }

  .share-result {
    .icon {
      width: 30px !important;
      height: 30px !important;
    }
  }

  .test-page {
    .shares {
      position: absolute !important;
    }
  }

</style>

